import {FieldValues, SubmitHandler} from "react-hook-form";
import {getStateFromLocalStorage} from "@/app/[locale]/common/utils/functions/getStateFromLocalStorage/getStateFromLocalStorage";
import {ACCESS_TOKEN_LOCAL_STORAGE_KEY, GENERAL_URL} from "../../../constants/app";
import {getAllNews} from "@/app/[locale]/common/utils/functions/getAllNews/getAllNews";
import {useState} from "react";

export const useCreateNews = (currentPage: number) => {
    const [ newsStatus, setNewsStatus ] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
    const [ error, setError ] = useState<null | string>(null);

    const createNews: SubmitHandler<FieldValues> = async (data) => {
        setNewsStatus('sending');
        const token = getStateFromLocalStorage(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        try {
            const res = await fetch(`${GENERAL_URL}/articles`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Content-Length': 'calculated when request is sent',
                    'Authorization': `Bearer ${token.accessToken}`,
                },
                body: JSON.stringify(data),
            });

            const response = await res.json();
            if (response.title) {
                await getAllNews(currentPage);
                setNewsStatus('success');
            } else {
                setNewsStatus('error');
                if (response.error) setError(response.error);
            }
        } catch (err) {
            setNewsStatus('error');
            console.log(err);
        }
    };

    return {
        newsStatus, createNews,
        error,
    };
};